export function getActiveUser() {
  const data = sessionStorage.getItem("activeUser");
  console.log("Active user data from session:", data);
  return JSON.parse(data);
}

export function getCurrentCenterId() {
  const user = getActiveUser();
  return user ? user.center_id : "";
}
export const commonApi = "https://backend.ispkd.com/api/";

export const centerId = getCurrentCenterId() ?? undefined;